import React from 'react';
import {
  useTranslation,
  translatePage,
} from '@ikea-customer-self-serve/gatsby-plugin-translations';

import SiteMetadata from '../components/SiteMetadata';
import TMarkUp from '../components/TMarkUp';
import styled from 'styled-components';
import HttpClient from '../services/HttpClient';
import { navigate } from 'gatsby';

const Heading = styled.h2`
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 2;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-top: 6%;
`

const Paragraph = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 2;
    font-size: 1.25rem;
    width: 25%;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 50px;
`;

const DownForMaintainancePage = (): JSX.Element => {
  const { t } = useTranslation();

  setTimeout(() => {
    const client = new HttpClient(false);
    const { status = 200 } = client.verifyBackend() as any;
    if (status == 200) {
      navigate('/');
    }
  }, 3e5);

  return (
    <>
      <SiteMetadata pageTitle={t('app.htmlTitle')} />
      <Heading>
        <TMarkUp value={t('error.title-503')} />
      </Heading>
      <Paragraph>
        <TMarkUp value={t('error.description-503')} />
      </Paragraph>
    </>
  );
};

export default translatePage()(DownForMaintainancePage);
